import { render, staticRenderFns } from "./SellerOfferInsightsPage.vue?vue&type=template&id=1b3c61bc&scoped=true"
import script from "./SellerOfferInsightsPage.vue?vue&type=script&lang=js"
export * from "./SellerOfferInsightsPage.vue?vue&type=script&lang=js"
import style0 from "./SellerOfferInsightsPage.vue?vue&type=style&index=0&id=1b3c61bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c61bc",
  null
  
)

export default component.exports